var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.show)?_c('router-link',{staticClass:"CreateInfo",attrs:{"tag":"div","to":{path:_vm.data.path||'',query:_vm.$route.query}}},[_c('span',[_vm._v("+")]),_c('p',[_vm._v(_vm._s(_vm.data.title))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }